export default "__VITE_ASSET__CH9YwRae__"